import React, { ReactNode } from 'react'
import { ScrollView, ScrollViewProps } from 'react-native'

interface IProps extends ScrollViewProps {
  children: ReactNode
}

export const BottomSheetScrollView = ({ children }: IProps) => <ScrollView>{children}</ScrollView>
